import { BuyOrSell, BuyOrSellLabel } from '../types/api/PriceComponent';

export const buyOrSellToLabel = (bos: BuyOrSell): BuyOrSellLabel => {
  switch (bos) {
    case BuyOrSell.BUY:
      return BuyOrSellLabel.BUY;
    case BuyOrSell.SELL:
      return BuyOrSellLabel.SELL;
    case BuyOrSell.BOTH:
      return BuyOrSellLabel.BOTH;
    default:
      return BuyOrSellLabel.BOTH;
  }
};

export const labelToBuyOrSell = (label: BuyOrSellLabel): BuyOrSell => {
  switch (label) {
    case BuyOrSellLabel.BUY:
      return BuyOrSell.BUY;
    case BuyOrSellLabel.SELL:
      return BuyOrSell.SELL;
    case BuyOrSellLabel.BOTH:
      return BuyOrSell.BOTH;
    default:
      return BuyOrSell.BOTH;
  }
};
